import script from "./AccountingModeChangeDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountingModeChangeDialog.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__